import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TermDetails } from './term-details';

export function TermSummary({
  term,
  allowEditTerm,
  isExtension,
  isActiveTerm,
  extensionReason,
  historyTerms,
}) {
  const [showHistoryTerms, setShowHistoryTerms] = useState(false);

  const onHistoryButtonClick = () => {
    setShowHistoryTerms(!showHistoryTerms);
  };

  return (
    <React.Fragment key={term.id}>
      <TermDetails
        term={term}
        allowEditTerm={allowEditTerm}
        onHistoryButtonClick={onHistoryButtonClick}
        isExtension={isExtension}
        isActiveTerm={isActiveTerm}
        extensionReason={extensionReason}
        showHistoryButton={historyTerms.length > 0}
        showHistoryTerms={showHistoryTerms}
        historyTerms={historyTerms}
      />
    </React.Fragment>
  );
}

TermSummary.propTypes = {
  term: PropTypes.shape({
    id: PropTypes.string.isRequired,
    effectiveAt: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
    lengthInWeeks: PropTypes.number.isRequired,
    billingRegularRate: PropTypes.number.isRequired,
    shiftType: PropTypes.string.isRequired,
    shiftsPerWeek: PropTypes.number.isRequired,
    hoursPerShift: PropTypes.number.isRequired,
    estimatedBudget: PropTypes.number.isRequired,
    timeoffDescription: PropTypes.string,
    extensionReason: PropTypes.string,
    createdByName: PropTypes.string,
    irrelevant: PropTypes.bool.isRequired,
    updatedFields: PropTypes.arrayOf(PropTypes.string),
    createdAt: PropTypes.string,
  }).isRequired,
  historyTerms: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      effectiveAt: PropTypes.string.isRequired,
      startDate: PropTypes.string.isRequired,
      endDate: PropTypes.string.isRequired,
      updatedAt: PropTypes.string.isRequired,
      lengthInWeeks: PropTypes.number.isRequired,
      billingRegularRate: PropTypes.number.isRequired,
      shiftType: PropTypes.string.isRequired,
      shiftsPerWeek: PropTypes.number.isRequired,
      hoursPerShift: PropTypes.number.isRequired,
      estimatedBudget: PropTypes.number.isRequired,
      timeoffDescription: PropTypes.string,
      extensionReason: PropTypes.string,
      createdByName: PropTypes.string,
      irrelevant: PropTypes.bool.isRequired,
      updatedFields: PropTypes.arrayOf(PropTypes.string),
      createdAt: PropTypes.string,
    })
  ),
  isExtension: PropTypes.bool,
  isActiveTerm: PropTypes.bool,
  extensionReason: PropTypes.string,
  allowEditTerm: PropTypes.bool,
};
